var apiUrlDev = "http://ict.u1link.com/activity"
var apiUrlProd = "/activity"

function getBaseUrl() {
    var baseUrl = ""
    if (process.env.NODE_ENV === "production") {
        baseUrl = apiUrlProd
    } else {
        baseUrl = apiUrlDev
    }
    return baseUrl;
}


export default {
    getBaseUrl
}


// WEBPACK FOOTER //
// ./src/common/js/requestUrl.js